import { createAction } from '@wix/communities-blog-client-common';
import { createPromisifiedAction } from '../../../common/actions-promisifier/create-promisified-action';

export const SET_ACTIVE_TAB = 'activeTab/SET';
export const setActiveTab = createAction(SET_ACTIVE_TAB);
export const setActiveTabPromisified = createPromisifiedAction(setActiveTab as any, () => null);
